module.exports = __webpack_public_path__ + "img/header-1.dad12ab.jpg";